import type {PickupPointsRequest} from '../../../types'
import {fetchPickUpDropOffPoints} from '../../deprecated/fetch-pick-up-drop-off-points'
import {
  type AddressPin,
  type PickupPoints,
  isUserAddressPin,
} from '../../models/pickup-route'
import {createAddressService} from './address-service'
import {createCityService} from './city-service'
import {toPickupDropoffRequest, toPickupPoints} from './mappers/toPickupPoints'
import type {PickupRouteServiceParams} from './types'

export function createPickupRouteService(params: PickupRouteServiceParams) {
  const {fetchCity} = createCityService(params)
  const {fetchSuggest, fetchAddressPin} = createAddressService(params)

  return {
    async fetchPickupPoints(
      addressPin: AddressPin,
      isSource?: boolean,
    ): Promise<PickupPoints> {
      const source = isUserAddressPin(addressPin)
        ? addressPin.coordinates
        : undefined

      return fetchCity(addressPin)
        .then(toPickupDropoffRequest)
        .then(selectPickupPointParams(isSource))
        .then(fetchPickUpDropOffPoints)
        .then(toPickupPoints(source))
    },
    fetchAddressPin,
    fetchSuggest,
  } as const
}

function selectPickupPointParams(isSource?: boolean) {
  return function _selectPickupPointParams(
    body: PickupPointsRequest,
  ): PickupPointsRequest {
    if (isSource) {
      body['available_for_c2c_dropoff'] = true
      body['payment_method'] = 'already_paid'
    } else {
      body['is_yandex_branded'] = true
      body['type'] = 'pickup_point'
    }

    return body
  }
}
